import { Button, Input, Modal } from "antd";
import RejectImg from "assets/refund_check.svg";
import { useState } from "react";

const { TextArea } = Input;

type RefundModalProps = {
  open: boolean;
  onConfirm: (remark: string, referenceNumber: string) => void;
  onCancel: () => void;
};

export const RefundModal = ({
  open,
  onConfirm,
  onCancel,
}: RefundModalProps) => {
  const [remark, setRemark] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");

  const handleConfirm = () => {
    onConfirm(remark, referenceNumber); // ✅ send both
    setRemark("");
    setReferenceNumber("");
  };

  const handleCancel = () => {
    setRemark("");
    setReferenceNumber("");
    onCancel();
  };

  return (
    <Modal open={open} footer={null} closable={false} centered width={420}>
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        <img
          src={RejectImg}
          alt="refund"
          style={{ marginBottom: "10px", width: "60px" }}
        />

        <div
          style={{ fontSize: "20px", fontWeight: 600, marginBottom: "10px" }}
        >
          Manual Refund
        </div>

        <div style={{ color: "#555", fontSize: "14px", marginBottom: "15px" }}>
          Are you sure you want to refund <strong>All Selected</strong>{" "}
          requests?
        </div>

        {/* Remark */}
        <div style={{ textAlign: "left", marginBottom: "5px" }}>Remark</div>
        <TextArea
          placeholder="Enter remark..."
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          rows={3}
          style={{ marginBottom: "15px" }}
        />

        {/* Reference Number */}
        <div style={{ textAlign: "left", marginBottom: "5px" }}>
          Reference Number
        </div>
        <Input
          placeholder="Enter reference number..."
          value={referenceNumber}
          onChange={(e) => setReferenceNumber(e.target.value)}
          style={{ marginBottom: "20px" }}
        />

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
          <Button onClick={handleCancel}>No</Button>

          <Button
            type="primary"
            danger
            onClick={handleConfirm}
            disabled={!remark.trim() || !referenceNumber.trim()} // ✅ require both
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};
